// Since sprint PR 7 the server sends each user only the notifications they receive or created;
// notificationUserId tells the two apart (actions/notification.js).
export const onCreateNotification = /* GraphQL */ `
  subscription OnCreateNotification {
    onCreateNotification {
      id
      content
      category
      link
      read
      actionUser {
        userID
        displayName
        photoURL
      }
      notificationUserId
      owner
      createdAt
      updatedAt
      user {
        id
        uuid
        displayName
        profileImage
        membership
        totalJournal
        followingCount
        followerCount
        bookOrder
        createdAt
        updatedAt
      }
    }
  }
`

// Since sprint PR 8b the server sends a chat message only to the users in its memberIds (the
// room's members); createMessage and deleteMessage return memberIds, which the filter matches.
// The page still checks messageChatRoomId (containers/ChatRoom.js): the subscription carries
// every room the user is in. chatRoom isn't selected: v2 leaves it null in these events.
const messageFields = `
      id
      content
      messageChatRoomId
      messageUserId
      memberIds
      createdAt
      updatedAt
      user {
        id
        uuid
        displayName
        profileImage
        membership
        totalJournal
        followingCount
        followerCount
        bookOrder
        createdAt
        updatedAt
      }
`
export const onCreateMessage = /* GraphQL */ `
  subscription OnCreateMessage {
    onCreateMessage {${messageFields}    }
  }
`
export const onDeleteMessage = /* GraphQL */ `
  subscription OnDeleteMessage {
    onDeleteMessage {${messageFields}    }
  }
`
